import React, { SVGAttributes } from 'react';

type CategoriesIconProps = SVGAttributes<unknown> & {
  isActive?: boolean;
};

export const CategoriesIcon = ({ isActive = false, ...props }: CategoriesIconProps): JSX.Element => (
  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
    <g clipPath='url(#clip0_4017_82541)'>
      <path
        d='M9.89063 1.45117H21.1406C21.1406 1.45117 22.5469 1.45117 22.5469 2.85742V4.26367C22.5469 4.26367 22.5469 5.66992 21.1406 5.66992H9.89063C9.89063 5.66992 8.48438 5.66992 8.48438 4.26367V2.85742C8.48438 2.85742 8.48438 1.45117 9.89063 1.45117Z'
        stroke='#485055'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={isActive ? '#485055' : 'none'}
      />
      <path
        d='M9.89063 9.88867H21.1406C21.1406 9.88867 22.5469 9.88867 22.5469 11.2949V12.7012C22.5469 12.7012 22.5469 14.1074 21.1406 14.1074H9.89063C9.89063 14.1074 8.48438 14.1074 8.48438 12.7012V11.2949C8.48438 11.2949 8.48438 9.88867 9.89063 9.88867Z'
        stroke='#485055'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={isActive ? '#485055' : 'none'}
      />
      <path
        d='M9.89063 18.3262H21.1406C21.1406 18.3262 22.5469 18.3262 22.5469 19.7324V21.1387C22.5469 21.1387 22.5469 22.5449 21.1406 22.5449H9.89063C9.89063 22.5449 8.48438 22.5449 8.48438 21.1387V19.7324C8.48438 19.7324 8.48438 18.3262 9.89063 18.3262Z'
        stroke='#485055'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={isActive ? '#485055' : 'none'}
      />
      <path
        d='M2.85938 1.45117H4.26563C4.26563 1.45117 5.67188 1.45117 5.67188 2.85742V4.26367C5.67188 4.26367 5.67188 5.66992 4.26563 5.66992H2.85938C2.85938 5.66992 1.45312 5.66992 1.45312 4.26367V2.85742C1.45312 2.85742 1.45312 1.45117 2.85938 1.45117Z'
        stroke='#485055'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={isActive ? '#485055' : 'none'}
      />
      <path
        d='M2.85938 9.88867H4.26563C4.26563 9.88867 5.67188 9.88867 5.67188 11.2949V12.7012C5.67188 12.7012 5.67188 14.1074 4.26563 14.1074H2.85938C2.85938 14.1074 1.45312 14.1074 1.45312 12.7012V11.2949C1.45312 11.2949 1.45312 9.88867 2.85938 9.88867Z'
        stroke='#485055'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={isActive ? '#485055' : 'none'}
      />
      <path
        d='M2.85938 18.3262H4.26563C4.26563 18.3262 5.67188 18.3262 5.67188 19.7324V21.1387C5.67188 21.1387 5.67188 22.5449 4.26563 22.5449H2.85938C2.85938 22.5449 1.45312 22.5449 1.45312 21.1387V19.7324C1.45312 19.7324 1.45312 18.3262 2.85938 18.3262Z'
        stroke='#485055'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={isActive ? '#485055' : 'none'}
      />
    </g>
    <defs>
      <clipPath id='clip0_4017_82541'>
        <rect width='24' height='24' fill='white' />
      </clipPath>
    </defs>
  </svg>
);
